<template>
    <div class="master-section single-column-layout section_0" v-for="(item, id_item) in single_column" :key="id_item">
        <div class="wysiwyg row justify-content-center px-0 px-md-1 mb-40px mb-md-0px mx-0 mx-md-1">
            <h2 class="agp-normal mb-25px" style="width:100%;" v-if="item.title && item.link_type === 'section'">
                <a :href="getLangUrl(item.button_link.url, baseUrl, locale)" class="master-section-link gray" :target="item.button_link.target">{{ item.title }}</a>
            </h2>
            <h2 class="agp-normal mb-25px" style="width:100%;" v-else-if="item.title && item.link_type === 'button' || item.title && item.link_type === 'none'" >{{ item.title }}</h2>

            <a :href="getLangUrl(item.button_link.url, baseUrl, locale)" class="master-section-link" v-if="item.link_type === 'section' && item.media.type == 'image'" :target="item.button_link.target">
                <img v-if="item.media.image_full" class="img-fluid d-none d-md-block mb-25px" :src="item.media.image_full" :alt="item.media.alt ?? ''" />
                <img v-if="item.media.image_full_mb" class="img-fluid d-md-none mb-25px" :src="item.media.image_full_mb" :alt="item.media.alt ?? ''" />
            </a>
            <a :href="getLangUrl(item.button_link.url, baseUrl, locale)" class="master-section-link" v-if="item.link_type === 'section' && item.media.type == 'video' && item.media.url" :target="item.button_link.target">
                <div class="alt-video-wrapper" :class="{'is-playing': id_item == 0}" :id="'alt-video-bg-' + id_item" >
                    <video class="master_video" :width="item.media.width" :height="item.media.height"  :controls="item.media.controls" :autoplay="id_item === 0" :muted="id_item == 0" playsinline>
                        <source :src="item.media.url" type="video/mp4">
                    </video>
                </div>
            </a>
            <a :href="getLangUrl(item.button_link.url, baseUrl, locale)" class="master-section-link" v-if="item.link_type === 'section' && item.media.type == 'embed' && item.media.code" :target="item.button_link.target">
                <div class="master_video_embed_container" v-html="item.media.code"></div>
            </a>

            <template v-if="item.link_type === 'button' && item.media.type == 'image' || item.link_type === 'none' && item.media.type == 'image'">
                <img v-if="item.media.image_full" class="img-fluid d-none d-md-block mb-25px" :src="item.media.image_full" :alt="item.media.alt ?? ''" />
                <img v-if="item.media.image_full_mb" class="img-fluid d-md-none mb-25px" :src="item.media.image_full_mb" :alt="item.media.alt ?? ''" />
            </template>
            <template v-if="item.link_type === 'button' && item.media.type == 'video' && item.media.url || item.link_type === 'none' && item.media.type == 'video' && item.media.url">
                <div class="alt-video-wrapper" :class="{'is-playing': id_item === 0}" :id="'alt-video-bg-' + id_item" >
                    <video class="master_video" :width="item.media.width" :height="item.media.height"  :controls="item.media.controls" :autoplay="id_item === 0" :muted="id_item === 0" playsinline>
                        <source :src="item.media.url" type="video/mp4">
                    </video>
                </div>
            </template>
            <template v-if="item.link_type === 'button' && item.media.type == 'embed' && item.media.code">
                <div class="master_video_embed_container" v-html="item.media.code"></div>
            </template>

            <div class="agp-light col-md-8 col-12 mb-md-25px pt_custom_section" style="width:100%;" v-if="item.content">
                <a 
                :href="getLangUrl(item.button_link.url, baseUrl, locale)"
                class="master-section-link pt_custom_link" 
                v-if="item.link_type === 'section'" 
                :target="item.button_link.target">
                </a>
                <div v-if="item.link_type === 'section'" v-html="convertUrlsToLocale(item.content, baseUrl, locale)"></div>
                <div v-if="item.link_type === 'button'" v-html="convertUrlsToLocale(item.content, baseUrl, locale)"></div>
                <div v-if="item.link_type === 'none'" v-html="convertUrlsToLocale(item.content, baseUrl, locale)"></div>
            </div>
            <div class="mb-25px wrapper-button" v-if="item.link_type === 'button' && item.button_link.title && item.label_button === ''">
                <a v-if="item.button_link.title" class="btn-outline-dark btn mt-15px mt-md-0px" :href="getLangUrl(item.button_link.url, baseUrl, locale)" :target="item.button_link.target">
                    {{ item.button_link.title }}<span class="css-arrow css-arrow-right" ></span>
                </a>
            </div>
            <div class="mb-25px wrapper-button" v-if="item.label_button != '' && item.slug == 'wedding-bands-book-appt'">
                <a class="btn-outline-dark btn mt-15px mt-md-0px appoint_form" @click="show_appointment_form()">
                    {{ item.label_button }}<span class="css-arrow css-arrow-right" ></span>
                </a>
                <div class="wrapper-form-consulation pt_none">
                    <ConsultationForm 
                        :data_key="item.site_key" 
                        :data_postId="item.post_id"
                        :data_store="item.store"
                        :data_page_title="item.slug"
                        data_store_label = "I WOULD LIKE TO HAVE MY CONSULTATION AT"
                        data_name_ph  = "Enter your name * "
                        data_email_ph = "Enter your email * "
                        data_phone_ph = "Enter your phone * "
                        ></ConsultationForm>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import ConsultationForm from "~/components/Corporate/ConsultationForm.vue"
    const props = defineProps(["data"]);
    const single_column = computed(() => props.data);
    const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { convertUrlsToLocale, getLangUrl } from '~/utils/getLangUrl';
    const show_appointment_form = () => {
        const form_appointment = document.querySelector(".wrapper-button .wrapper-form-consulation");
        if(form_appointment){
            if (form_appointment.classList.contains("pt_none")) {
                form_appointment.classList.remove("pt_none");
            } else {
                form_appointment.classList.add("pt_none");
            }
        }
    }
</script>
<style scoped>
    :deep(#name-form-group .alt-form-group > label){
        display: none;
    }
    :deep(#email-form-group .alt-form-group > label){
        display: none;
    }
    :deep(#phone-form-group .alt-form-group > label){
        display: none;
    }
</style>